<template>
  <div>
    
    
    <h1>{{location}}</h1>
    <div v-if="!isLoading">
      
      <!-- {{ Object.keys(table[0])}} -->
      
      <!-- {{ keys }} -->
      
      <!-- {{table}} -->
      <!-- {{totals}} -->
      
      
      <div v-if="filteredTable.length > 0" style="width:425px"> 
        <BasicTableComponent 
          :list="subtotals" 
          :totals="totals"
          tableClass="table2excel"
          :tableID="`${location}_Cashiers`"
          :showColumns="['cashier' , 'Hours', 'RoundedHours']"
          :columnOrder="['cashier', 'Hours', 'RoundedHours']"
          :formatters="{
            'day' : ['d', 'ddd MM/DD/YY'], 
            'StartDateTime' : ['d', 'h:mm a'], 
            'EndDateTime' : ['d', 'h:mm a'], 
            'Start' : ['d', 'h:mm a'], 
            'End' : ['d', 'h:mm a'], 
            'Hours' : ['n', '0,0.00'], 
            'RoundedHours' : ['n', '0,0.00'], 
          }"
          :titles="{
            'StartDateTime' : 'Shift Start', 
            'EndDateTime' : 'Shift End', 
            'RoundedHours' : 'Rounded Hours',
          }"
        />

        <BasicTableComponent 
          :list="filteredTable" 
          :totals="totals"
          tableClass="table2excel"
          :tableID="`${location}_Days`"
          :showColumns="['day', 'StartDateTime', 'EndDateTime', 'cashier', 'Start', 'End', 'Hours', 'RoundedHours']"
          :columnOrder="['day', 'StartDateTime', 'EndDateTime', 'cashier', 'Start', 'End', 'Hours' , 'RoundedHours']"
          :formatters="{
            'day' : ['d', 'ddd MM/DD/YY'], 
            'StartDateTime' : ['d', 'h:mm a'], 
            'EndDateTime' : ['d', 'h:mm a'], 
            'Start' : ['d', 'h:mm a'], 
            'End' : ['d', 'h:mm a'], 
            'Hours' : ['n', '0,0.00'], 
            'RoundedHours' : ['n', '0,0.00'], 
          }"
          :titles="{
            'StartDateTime' : 'Shift Start', 
            'EndDateTime' : 'Shift End', 
            'RoundedHours' : 'Rounded Hours', 
          }"
        />
        
      </div>
      
    </div>
    
    
  </div>
</template>

<script>
export default {
  name: 'CashiersTable',
  inject:['page'],
  props:['location', 'storeName', 'filter', 'startBuffer', 'endBuffer'],
  computed:{
    store(){return this.page.$refs[this.storeName]},
    keys(){return this.$util.keys(this.table)},
    isLoading(){
      if(this.store.data[this.location] === undefined)
        return true;
      return this.store.data[this.location].isLoading;
    },
    table(){
      if (this.isLoading)
        return;
      let t = this.store.pivotedData[this.location].shifts;
      const calculatedCols = (r) => {
        const Start = moment(r.StartDateTime).subtract(this.startBuffer || 10, 'minutes').toDate()
        const End = moment(r.EndDateTime).add(this.endBuffer || 10, 'minutes').toDate()
        const Hours = moment.duration(moment(End).diff(moment(Start), 'seconds'), 'seconds').asHours()
        const RoundedHours = parseFloat((Math.round(Hours * 4) / 4).toFixed(2));
        return {Start, End, Hours, RoundedHours}
      }
      t = t.map(r=> ({...r, ...calculatedCols(r)})) 
      return t;
      
    },
    filteredTable(){
      if (this.isLoading)
        return;
      return this.table.filter(r=>(r.cashier || "").toLowerCase().includes(this.filter.toLowerCase()));
    },
    totals(){
      if (this.isLoading)
        return;
      let totals = this.$math.sumKeys(this.filteredTable) 
      totals = this.$util.deleteObjectProperties(totals, ['StartDateTime', 'EndDateTime', 'Start', 'End'])
      totals.day = 'Total'
      return [totals]
    },
    subtotals(){
      if (this.isLoading)
        return;
      let subtotals = this.$math.subtotalsForKey(this.filteredTable, 'cashier')
      subtotals = this.$util.deleteObjectProperties(subtotals, ['day', 'StartDateTime', 'EndDateTime', 'Start', 'End'])
      return subtotals
    },


  },
}
</script>